@if (cell.wrapText) {
  <span class="sh-wrap-text">
    <sh-html-parser [message]="value$ | async"></sh-html-parser>
  </span>
} @else {
  <sh-list-row-title [title]="value$ | async"></sh-list-row-title>
}

